module.exports = __webpack_public_path__ + "images/Talent2Test-logo.png";